import { z } from 'zod'

import { ProfileName } from '@/business-logic/profile/domain/ProfileName'

const LSP3ProfileSchema = z.object({
  LSP3Profile: z.object({
    name: z.string(),
  }),
})

export function mapDTOToDomain(lsp3ProfileDTO: unknown): ProfileName {
  try {
    const lsp3Profile = LSP3ProfileSchema.parse(lsp3ProfileDTO)
    return ProfileName.create({
      profileNameValue: lsp3Profile.LSP3Profile.name,
    })
  } catch (error) {
    throw new Error(`Error while mapping profile name from DTO to domain`, {
      cause: error,
    })
  }
}
